type FirebaseErrorLike = {
  code?: unknown;
};

function errorCode(error: unknown) {
  const code = (error as FirebaseErrorLike | null)?.code;
  return typeof code === "string" ? code.toLowerCase() : "";
}

export function friendlyFirebaseError(error: unknown, fallback: string) {
  const rawCode = errorCode(error);
  const code = rawCode.startsWith("functions/") ? rawCode.slice("functions/".length) : rawCode;

  switch (code) {
    case "auth/invalid-credential":
    case "auth/invalid-login-credentials":
    case "auth/user-not-found":
    case "auth/wrong-password":
      return "Email ou mot de passe incorrect.";
    case "auth/email-already-in-use":
      return "Un compte utilise déjà cette adresse email.";
    case "auth/invalid-email":
      return "Adresse email invalide.";
    case "auth/weak-password":
      return "Choisis un mot de passe plus robuste.";
    case "auth/too-many-requests":
      return "Trop de tentatives. Attends un moment puis réessaie.";
    case "auth/user-disabled":
      return "Ce compte a été désactivé.";
    case "auth/user-token-expired":
    case "auth/requires-recent-login":
      return "Ta session a expiré. Reconnecte-toi puis réessaie.";
    case "auth/network-request-failed":
    case "network-request-failed":
    case "deadline-exceeded":
    case "unavailable":
      return "Connexion impossible. Vérifie ton réseau puis réessaie.";
    case "unauthenticated":
      return "Ta session a expiré. Reconnecte-toi puis réessaie.";
    case "permission-denied":
    case "firestore/permission-denied":
      return "Cette action n’est pas autorisée pour ce compte.";
    case "failed-precondition":
      return "Cette action n’est pas disponible pour le moment.";
    case "resource-exhausted":
      return "Trop de demandes. Attends un moment puis réessaie.";
    case "not-found":
      return "La ressource demandée est introuvable.";
    case "already-exists":
      return "Cette ressource existe déjà.";
    case "storage/unauthorized":
      return "Tu n’as pas l’autorisation d’utiliser ce fichier.";
    default:
      return fallback;
  }
}
